module.exports = __webpack_public_path__ + "static/media/ANAHUAC_multiusos.c907bba0.png";